import React, { ReactElement, useEffect } from "react";
import { Audience, BasicAudience } from "modules/audiences";
import MultiselectAndChipsWithSearch from "modules/common/components/forms/inputs/multiSelectAndChipsWithSearch";

interface ComponentProps {
    audiences: Audience[];
    selected: BasicAudience[];
    onSelect: (audienceId: BasicAudience[]) => void;
    anchorEl: HTMLElement | null;
    setAnchorEl: (anchorEl: HTMLElement | null) => void;
    emptyChipContents: string | ReactElement;
}

const AudienceSearchAndChips: React.FunctionComponent<ComponentProps> = (props) => {
    const [filteredAudiences, setFilteredAudiences] = React.useState<Audience[]>([]);

    useEffect(() => setFilteredAudiences(props.audiences), [props.audiences]);

    return (
        <MultiselectAndChipsWithSearch
            defaultOptions={filteredAudiences.map(a => ({id: a.id, name: a.displayName}))}
            selectedOptions={props.selected}
            onChange={props.onSelect}
            buttonText= {"Edit Audiences"}
            buttonId={"audience-filters-button"}
            chipListStyle={{
                chipListClassName: "topic-create-chips",
                emptyChipStyling: {
                    show: true,
                    contents: props.emptyChipContents,
                    styling: {
                        opacity: 0.38,
                        fontSize: "12px"
                    }
                }
            }}
            nestingAllowed={false}
        />
    );
};

export default AudienceSearchAndChips;